<template>
    <PageView>
        <a-card title="列表">
            <!-- <a-button type="primary" slot="extra" @click="$router.push({ name: `problemEdit` })">添加分类</a-button> -->
            <a-button type="primary" slot="extra" @click="showModal">添加分类</a-button>
            <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>
        <a-modal v-model="modalVisible" title="编辑" :ok-text="modalEditMode ? '保存' : '确定'" @ok="handleOk">
            <a-form :form="form" style="width: 350px">
                    <a-form-item label="问题名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-model="formData.title"
                            placeholder="请输入问题名称"
                        />
                    </a-form-item>
                    <!-- <a-form-item label="排序号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`sort`, { rules: [{ required: true, message: '请输入排序' }] }]"
                            placeholder="请输入排序"
                        />
                    </a-form-item> -->
                </a-form>
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import GoodsCats from '../../api/GoodsCats.js'
import Problem from "../../api/problem.js"
export default {
    name: 'GoodscatsList',
    data () {
        return {
            form: this.$form.createForm(this),
            modalVisible: false,
            modalEditMode: false,
            formData: {
                title: '',
            },
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },



            // loading: true,
            columns: [
                {
                    title: '名称',
                    dataIndex: 'name',
                    customRender: (v) => <a>{v}</a>
                },
                {
                    title: '添加时间',
                    dataIndex: 'add_time',
                    customRender: (v) => this.timeOne(v)
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item onClick={() => {
                                        this.changeBanner(v.id,"deleteCategory","删除")
                                    }}>删除
                                    </a-menu-item>
                                    <a-menu-item onClick={() => {
                                        this.changeList(v,"编辑")
                                    }}>编辑
                                    </a-menu-item>
                                </a-menu>
                                <a-button>操作 <a-icon type="down"/></a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            dataList: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            listId:''
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        showModal() {
            console.log(' this.formData.title', this.formData.title)
            this.formData.title == '';
            this.modalEditMode = false;
            this.modalVisible = true;
        },
        handleOk() {
                    // this.id &&
                if ( this.modalEditMode) {
                        // 编辑模式
                        Problem.SaveCategory({title:this.formData.title , id:this.listId}).then(res => {
                            this.getList();
                            this.formData.title= '';
                        }).catch(res => {

                        })
                } else {
                    // 添加模式
                    Problem.AddCategory({title:this.formData.title}).then(res => {
                            this.getList();
                            this.formData.title= '';
                        }).catch(res => {

                        })
                }
                this.modalVisible = false;
        },
        getList () {
           Problem.categoryList({
                page: this.current,
                num: this.pageSize,
            }).then(res => {
                console.log('res',res)
                this.dataList = res.result
            })
        },
        changeList(v){
            this.listId = v.id;
            this.formData.title = v.name;
            this.modalVisible = true;
            this.modalEditMode = true
        },
        changeBanner (id,methods,title) {
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}此分类吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Problem[methods]({ id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}
</style>